import {applyMiddleware, Middleware} from 'redux';
import ReduxThunk from 'redux-thunk';
import {composeWithDevTools} from 'redux-devtools-extension/developmentOnly';

var middleware: Array<Middleware> = [ReduxThunk];

export default  composeWithDevTools(applyMiddleware(...middleware));
